import { useState } from 'react';
import Image from 'next/image';
const HeaderMobile = () => {
  const [index, setIndex] = useState(0);
  return (
    <>
      <div className="flex sm:hidden justify-center items-center bg-secondary mx-auto rounded-[15px] px-8 py-5 mt-5 text-white">
        {index === 0 && (
          <div className="flex flex-col gap-2 items-center">
            <Image
              src="/tollfree_icon.svg"
              width={30}
              height={30}
              alt="toll free"
            />
            <h2 className="text-[14px] font-[500]">Toll Free</h2>
            <p className="text-xs font-normal">1-888-961-6584</p>
          </div>
        )}
        {index === 1 && (
          <div className="flex flex-col gap-2 items-center">
            <Image src="/local_icon.svg" width={30} height={30} alt="local" />
            <h2 className="text-[14px] font-[500] ">Local</h2>
            <p className="text-xs font-normal">1-289-271-9767</p>
          </div>
        )}
        {index === 2 && (
          <div className="flex flex-col gap-2 items-center">
            <Image src="/fax_icon.svg" width={30} height={30} alt="fax" />
            <h2 className="text-[14px] font-[500] ">Fax</h2>
            <p className="text-xs font-normal">1-888-908-6056</p>
          </div>
        )}
      </div>
      <div className="mt-4 mx-auto sm:hidden">
        <div className="float-right flex justify-end">
          <button
            onClick={() => setIndex(0)}
            className={`text-[16px] font-[500] px-4 ${
              index === 0
                ? 'scale-125 text-[#9B9B9B]'
                : 'scale-100 text-[#DBDBDB] '
            }`}
          >
            01
          </button>
          <button
            onClick={() => setIndex(1)}
            className={` text-[16px] font-[500] px-4 ${
              index === 1
                ? 'scale-125 text-[#9B9B9B]'
                : 'scale-100 text-[#DBDBDB] '
            }`}
          >
            02
          </button>
          <button
            onClick={() => setIndex(2)}
            className={` text-[16px] font-[500] px-4 ${
              index === 2
                ? 'scale-125 text-[#9B9B9B]'
                : 'scale-100 text-[#DBDBDB] '
            }`}
          >
            03
          </button>
        </div>
      </div>
    </>
  );
};

export default HeaderMobile;
